import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.acronis.backup.sso;

const {
	actions,
	reducer,
	sagas,
	selectors: defaultSelectors,
} = createAPIModule({
	getStateSlice,
	actionType: 'ACRONIS_BACKUP_SSO',
	method: 'POST',
	url: '/acronis/backup/sso.json',
});

const selectors = {
	...defaultSelectors,
};

export { actions, reducer, sagas, selectors };
